import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import Person from '@material-ui/icons/Person'
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { BrowserRouter as Router, Switch, Route, Link } from "react-router-dom";

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },

}));

// https://reactgo.com/material-ui-react-tutorial/

export default function ButtonAppBar() {
  const classes = useStyles();

  const [anchorEl, setAnchorEl] = React.useState(null)
  const [anchorE2, setAnchorE2] = React.useState(null)

  const menu1ClickHandler = event => {
    setAnchorEl(event.currentTarget);
  };

  const menu1CloseHandler = () => {
    setAnchorEl(null);
  };

  const menu2ClickHandler = event => {
    setAnchorE2(event.currentTarget);
  };

  const menu2CloseHandler = () => {
    setAnchorE2(null);
  };
  const preventDefault = () => {
    this.preventDefault()
  }
// https://www.vexplode.com/en/programming/material-ui-react-router-7-navigation-menu/?t=00:01:21
  return (
    <div className={classes.root}>
      <AppBar position="static">
        <Toolbar>
          <IconButton edge="start" className={classes.menuButton} color="inherit" aria-label="menu" aria-controls="simple-menu" aria-haspopup="true" onClick={menu1ClickHandler}>
            <MenuIcon></MenuIcon>
          </IconButton>
          <Menu
            id="simple-menu"
            anchorEl={anchorEl}
            keepMounted
            open={Boolean(anchorEl)}
            onClose={menu1CloseHandler}
          >
            <MenuItem onClick={menu1CloseHandler} component={Link} to="/">Home</MenuItem>
            <MenuItem onClick={menu1CloseHandler} component={Link} to="/about">About</MenuItem>
            <MenuItem onClick={menu1CloseHandler} component={Link} to="/calculators/debtpayoff">Debt Payoff</MenuItem>
          </Menu>

          <Typography variant="h6" className={classes.title}>
            WBTeam Debt Financial Calculators
          </Typography>
          {/* <Button color="inherit" component={Link} to='/'>Home</Button>
          <Button color="inherit" component={Link} to='/about'>About</Button> */}
          <IconButton edge="start" className={classes.menuButton} color="inherit" aria-label="user" aria-controls="user-menu" aria-haspopup="true" onClick={menu2ClickHandler}>
            <Person></Person>
          </IconButton>

          <Menu
            id="user-menu"
            anchorEl={anchorE2}
            keepMounted
            open={Boolean(anchorE2)}
            onClose={menu2CloseHandler}
          >
            <MenuItem onClick={menu2CloseHandler}>My account</MenuItem>
            <MenuItem onClick={menu2CloseHandler}>Logout</MenuItem>
          </Menu>
        </Toolbar>
      </AppBar>
    </div>
  );
}